import React, {
    useEffect,
    useMemo,
    useCallback,
    useState,
    useRef,
} from "react";
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './meetings.css'
import MeetingModal from './MeetingModal'
import $ from 'jquery'
import { getMeetings, getMeeting } from './Api'
import { toast } from "react-toastify";

const localizer = momentLocalizer(moment)
moment.locale('en-GB');

const MeetCalendar = props => {
    const [startDate, setstartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [events, setEvents] = useState([])

    const [meeting, setMeeting] = useState(null);

    const [viewStart, setViewStart] = useState(moment().startOf('week').utc().format());
    const [viewEnd, setViewEnd] = useState( moment().endOf('week').utc().format());


    const handleSelectSlot = ({ start, end, resourceId }) => {
        console.log(start, end)
        let meetingStart = moment(start).format('YYYY-MM-DDTHH:mm:ss')
        let slotEnd = moment(end).format('YYYY-MM-DDTHH:mm:ss')
        let meetingEnd = moment(start).add(30, 'minutes').format('YYYY-MM-DDTHH:mm:ss')

        let currentDate = moment().format('YYYY-MM-DDTHH:mm:ss')
       
        if (meetingStart < currentDate && currentDate <= slotEnd){

            setstartDate(currentDate);
            setEndDate(moment().add(30, 'minutes').format('YYYY-MM-DDTHH:mm:ss'))

            $('#createMeeting').modal('show');
            return 
        }
         
        if (meetingStart < currentDate) {
     
            toast.info("Meetings can't be scheduled in a past date")
            return
        }


        setstartDate(meetingStart);
        setEndDate(meetingEnd)


        $('#createMeeting').modal('show');
    }

    const refresh = () => {

        fetchMeetings(viewStart,viewEnd)
    }
    const fetchMeetings= (s ,e)=>{
        setEvents([])
        getMeetings(s,e).then(data => {
            data = data.map(d => {
                d = {
                    title: d.title,
                    start: new Date(d.startDateTime),
                    end: new Date(d.endDateTime),
                    id: d.id
                }
                return d
            })


            setEvents(data)

        })
    }


    useEffect(() => {
        console.log("week sss", moment().startOf('week'), moment().endOf('week'))

        fetchMeetings(moment().startOf('week').utc().format(), moment().endOf('week').utc().format())
        $('#createMeeting').on('hidden.bs.modal', function () {
            // do something…
            try { setMeeting(null) } catch (e) { }
        });

    }, [])



    return (

        <div className="meet-cal" style={{ padding: '40px' }}>

            <MeetingModal meeting={meeting} startDate={startDate} endDate={endDate} refresh={refresh} />
            <Calendar
                selectable
                // onSelectSlot={e => alert(e)}
                onSelectSlot={handleSelectSlot}
                onSelectEvent={event => {
                    getMeeting(event.id).then((meeting) => {
                        setMeeting(meeting);
                        $('#createMeeting').modal('show');
                    })

                }}
                localizer={localizer}
                events={events}
                step={60}
                view='week'
                views={['week']}
                showMultiDayTimes={true}
                dayLayoutAlgorithm="no-overlap"

                onRangeChange={(ar) => {
                    let s = ar[0];
                    let e  = ar[6];
                    s = moment(s).utc().format()
                    e = moment(e).add(24,'hours').utc().format()
                    setViewStart(s)
                    setViewEnd(e)
                    fetchMeetings(s,e)

                }}
          
            />
        </div>
    )
}

export default MeetCalendar;